/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "invitations": {
            "nested": {
              "CardInvitationState": {
                "values": {
                  "CARD_INVITATION_STATE_DO_NOT_USE": 0,
                  "OPEN": 1,
                  "CLAIMED": 2,
                  "CLOSED": 3
                }
              },
              "CardInvitationClosedReason": {
                "values": {
                  "CLOSED_REASON_DO_NOT_USE": 0,
                  "EXPIRED": 1,
                  "REVOKED": 2
                }
              },
              "CardInvitation": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "inviterPersonToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "inviteePersonToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.bizbank.invitations.CardInvitationState",
                    "id": 5,
                    "rule": "optional"
                  },
                  "closedReason": {
                    "type": ".squareup.bizbank.invitations.CardInvitationClosedReason",
                    "id": 6,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationState && !$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitationClosedReason && !$root.nested?.squareup?.nested?.bizbank?.nested?.invitations?.nested?.CardInvitation) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE CardInvitationState @ squareup/bizbank/card_invitation.proto at 14:1
 */
export const CardInvitationState = $root.lookupEnum('squareup.bizbank.invitations.CardInvitationState').values;
/**
 * SOURCE CardInvitationClosedReason @ squareup/bizbank/card_invitation.proto at 34:1
 */
export const CardInvitationClosedReason = $root.lookupEnum('squareup.bizbank.invitations.CardInvitationClosedReason').values;
/**
 * SOURCE CardInvitation @ squareup/bizbank/card_invitation.proto at 48:1
 */
export const CardInvitation = $root.lookupType('squareup.bizbank.invitations.CardInvitation');
fixType(CardInvitation);
Builder.createAndAttachToType(CardInvitation);
